module.exports = __webpack_public_path__ + "img/external-drives.c22b28cc.svg";